import * as IF from "infrontjs";
import template from './template.html';

class PackCard extends HTMLElement
{
    constructor()
    {
        super();
        this._isConnected = false;
        this._pack = null;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.app = IF.App.get();
            this.render();

            this._isConnected = true;
        }
    }

    get pack()
    {
        return this._pack;
    }

    set pack( val )
    {
        this._pack = val;
        if ( this._isConnected )
        {
            this.render();
        }
    }

    _getDescription()
    {
        if ( !this._pack?.description )
        {
            return 'No description';
        }
        const desc = this._pack.description;
        return desc.length > 100 ? desc.substring( 0, 100 ) + '...' : desc;
    }

    _formatDate( dateStr )
    {
        if ( !dateStr )
        {
            return '---';
        }
        return new Date( dateStr ).toLocaleDateString();
    }

    render()
    {
        if ( !this.app?.view || !this._pack )
        {
            return;
        }

        this.app.view.render(
            this,
            template,
            {
                pack: this._pack,
                description: this._getDescription(),
                createdAt: this._formatDate( this._pack.createdAt ),
                updatedAt: this._formatDate( this._pack.updatedAt )
            }
        );

        const deleteButton = this.querySelector( '[data-type="pack-card-delete"]' );
        if ( deleteButton )
        {
            deleteButton.addEventListener( 'click', () => {
                this.dispatchEvent( new CustomEvent( 'delete', {
                    detail: { packId: this._pack.id },
                    bubbles: true
                }));
            });
        }

        const toggleStatusButton = this.querySelector( '[data-type="pack-card-toggle-status"]' );
        if ( toggleStatusButton )
        {
            toggleStatusButton.addEventListener( 'click', () => {
                this._onToggleStatus();
            });
        }
    }

    async _onToggleStatus()
    {
        const isActive = this._pack.status === 'ACTIVE';
        const action = isActive ? 'deactivate' : 'activate';
        const actionLabel = isActive ? 'Deactivate' : 'Activate';

        const confirmed = await this.app.view.confirm(
            `${actionLabel} Pack`,
            `Do you want to ${action} this pack?`
        );

        if ( confirmed )
        {
            const pageContent = this.app.view.pageContent;
            const message = isActive ? 'Deactivating pack...' : 'Activating pack...';
            this.app.view.blockUI( pageContent, message );

            const newStatus = isActive ? 'INACTIVE' : 'ACTIVE';
            const { result } = await this.app.api.put(
                `/pack/${this._pack.id}/status`,
                { status: newStatus }
            );

            this.app.view.unblockUI( pageContent );

            if ( result.status === 200 )
            {
                this._pack.status = newStatus;
                this.render();
                this.app.view.toast( `Pack ${action}d successfully`, 'success' );
            }
            else
            {
                this.app.view.toast( `Failed to ${action} pack`, 'error' );
            }
        }
    }
}

customElements.define( 'pack-card', PackCard );
